export { useIsAIAssistantEnabledForPortal } from './use-is-ai-assistant-enabled-for-portal';
